import WebSocketClient from '@clients/web-socket.client';
import { ISubscribe } from '@app-types/websocket/subscription.types';

const socket = WebSocketClient.getInstance();

export function subscribe(data: ISubscribe) {
  socket.sendJSON({
    subscribe: data,
  });
}





// WEBPACK FOOTER //
// ./src/services/subscription/subscription.websocket.ts